import React from 'react';
import ReactDOM from 'react-dom';
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
function generatePatches(state, basepath, patches, inversePatches, baseValue, resultValue) {
  if (patches) if (Array.isArray(baseValue)) generateArrayPatches(state, basepath, patches, inversePatches, baseValue, resultValue);else generateObjectPatches(state, basepath, patches, inversePatches, baseValue, resultValue);
}
function generateArrayPatches(state, basepath, patches, inversePatches, baseValue, resultValue) {
  var shared = Math.min(baseValue.length, resultValue.length);
  for (var i = 0; i < shared; i++) {
    if (state.assigned[i] && baseValue[i] !== resultValue[i]) {
      var path = basepath.concat(i);
      patches.push({
        op: "replace",
        path: path,
        value: resultValue[i]
      });
      inversePatches.push({
        op: "replace",
        path: path,
        value: baseValue[i]
      });
    }
  }
  if (shared < resultValue.length) {
    // stuff was added
    for (var _i = shared; _i < resultValue.length; _i++) {
      var _path = basepath.concat(_i);
      patches.push({
        op: "add",
        path: _path,
        value: resultValue[_i]
      });
    }
    inversePatches.push({
      op: "replace",
      path: basepath.concat("length"),
      value: baseValue.length
    });
  } else if (shared < baseValue.length) {
    // stuff was removed
    patches.push({
      op: "replace",
      path: basepath.concat("length"),
      value: resultValue.length
    });
    for (var _i2 = shared; _i2 < baseValue.length; _i2++) {
      var _path2 = basepath.concat(_i2);
      inversePatches.push({
        op: "add",
        path: _path2,
        value: baseValue[_i2]
      });
    }
  }
}
function generateObjectPatches(state, basepath, patches, inversePatches, baseValue, resultValue) {
  each(state.assigned, function (key, assignedValue) {
    var origValue = baseValue[key];
    var value = resultValue[key];
    var op = !assignedValue ? "remove" : key in baseValue ? "replace" : "add";
    if (origValue === baseValue && op === "replace") return;
    var path = basepath.concat(key);
    patches.push(op === "remove" ? {
      op: op,
      path: path
    } : {
      op: op,
      path: path,
      value: value
    });
    inversePatches.push(op === "add" ? {
      op: "remove",
      path: path
    } : op === "remove" ? {
      op: "add",
      path: path,
      value: origValue
    } : {
      op: "replace",
      path: path,
      value: origValue
    });
  });
}
function applyPatches(draft, patches) {
  for (var i = 0; i < patches.length; i++) {
    var patch = patches[i];
    var path = patch.path;
    if (path.length === 0 && patch.op === "replace") {
      draft = patch.value;
    } else {
      var base = draft;
      for (var _i3 = 0; _i3 < path.length - 1; _i3++) {
        base = base[path[_i3]];
        if (!base || (typeof base === "undefined" ? "undefined" : _typeof(base)) !== "object") throw new Error("Cannot apply patch, path doesn't resolve: " + path.join("/"));
      }
      var key = path[path.length - 1];
      switch (patch.op) {
        case "replace":
        case "add":
          // TODO: add support is not extensive, it does not support insertion or `-` atm!
          base[key] = patch.value;
          break;
        case "remove":
          if (Array.isArray(base)) {
            if (key === base.length - 1) base.length -= 1;else throw new Error("Remove can only remove the last key of an array, index: " + key + ", length: " + base.length);
          } else delete base[key];
          break;
        default:
          throw new Error("Unsupported patch operation: " + patch.op);
      }
    }
  }
  return draft;
}
var NOTHING = typeof Symbol !== "undefined" ? Symbol("immer-nothing") : defineProperty({}, "immer-nothing", true);
var PROXY_STATE = typeof Symbol !== "undefined" ? Symbol("immer-proxy-state") : "__$immer_state";
var RETURNED_AND_MODIFIED_ERROR = "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.";
function verifyMinified() {}
var inProduction = typeof process !== "undefined" && process.env.NODE_ENV === "production" || verifyMinified.name !== "verifyMinified";
var autoFreeze = !inProduction;
var useProxies = typeof Proxy !== "undefined" && typeof Reflect !== "undefined";
function getUseProxies() {
  return useProxies;
}
function isProxy(value) {
  return !!value && !!value[PROXY_STATE];
}
function isProxyable(value) {
  if (!value) return false;
  if ((typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") return false;
  if (Array.isArray(value)) return true;
  var proto = Object.getPrototypeOf(value);
  return proto === null || proto === Object.prototype;
}
function freeze(value) {
  if (autoFreeze) {
    Object.freeze(value);
  }
  return value;
}
var assign = Object.assign || function assign(target, value) {
  for (var key in value) {
    if (has(value, key)) {
      target[key] = value[key];
    }
  }
  return target;
};
function shallowCopy(value) {
  if (Array.isArray(value)) return value.slice();
  var target = value.__proto__ === undefined ? Object.create(null) : {};
  return assign(target, value);
}
function each(value, cb) {
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      cb(i, value[i]);
    }
  } else {
    for (var key in value) {
      cb(key, value[key]);
    }
  }
}
function has(thing, prop) {
  return Object.prototype.hasOwnProperty.call(thing, prop);
}

// given a base object, returns it if unmodified, or return the changed cloned if modified
function finalize(base, path, patches, inversePatches) {
  if (isProxy(base)) {
    var state = base[PROXY_STATE];
    if (state.modified === true) {
      if (state.finalized === true) return state.copy;
      state.finalized = true;
      var result = finalizeObject(useProxies ? state.copy : state.copy = shallowCopy(base), state, path, patches, inversePatches);
      generatePatches(state, path, patches, inversePatches, state.base, result);
      return result;
    } else {
      return state.base;
    }
  }
  finalizeNonProxiedObject(base);
  return base;
}
function finalizeObject(copy, state, path, patches, inversePatches) {
  var base = state.base;
  each(copy, function (prop, value) {
    if (value !== base[prop]) {
      // if there was an assignment on this property, we don't need to generate
      // patches for the subtree
      var _generatePatches = patches && !has(state.assigned, prop);
      copy[prop] = finalize(value, _generatePatches && path.concat(prop), _generatePatches && patches, inversePatches);
    }
  });
  return freeze(copy);
}
function finalizeNonProxiedObject(parent) {
  // If finalize is called on an object that was not a proxy, it means that it is an object that was not there in the original
  // tree and it could contain proxies at arbitrarily places. Let's find and finalize them as well
  if (!isProxyable(parent)) return;
  if (Object.isFrozen(parent)) return;
  each(parent, function (i, child) {
    if (isProxy(child)) {
      parent[i] = finalize(child);
    } else finalizeNonProxiedObject(child);
  });
}
function is(x, y) {
  // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

// @ts-check

var proxies = null;
var objectTraps = {
  get: get$1,
  has: function has$$1(target, prop) {
    return prop in source(target);
  },
  ownKeys: function ownKeys(target) {
    return Reflect.ownKeys(source(target));
  },
  set: set$1,
  deleteProperty: deleteProperty,
  getOwnPropertyDescriptor: getOwnPropertyDescriptor,
  defineProperty: defineProperty$1,
  setPrototypeOf: function setPrototypeOf() {
    throw new Error("Immer does not support `setPrototypeOf()`.");
  }
};
var arrayTraps = {};
each(objectTraps, function (key, fn) {
  arrayTraps[key] = function () {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function (state, prop) {
  if (isNaN(parseInt(prop))) throw new Error("Immer does not support deleting properties from arrays: " + prop);
  return objectTraps.deleteProperty.call(this, state[0], prop);
};
arrayTraps.set = function (state, prop, value) {
  if (prop !== "length" && isNaN(parseInt(prop))) throw new Error("Immer does not support setting non-numeric properties on arrays: " + prop);
  return objectTraps.set.call(this, state[0], prop, value);
};
function createState(parent, base) {
  return {
    modified: false,
    // this tree is modified (either this object or one of it's children)
    assigned: {},
    // true: value was assigned to these props, false: was removed
    finalized: false,
    parent: parent,
    base: base,
    copy: undefined,
    proxies: {}
  };
}
function source(state) {
  return state.modified === true ? state.copy : state.base;
}
function get$1(state, prop) {
  if (prop === PROXY_STATE) return state;
  if (state.modified) {
    var value = state.copy[prop];
    if (value === state.base[prop] && isProxyable(value))
      // only create proxy if it is not yet a proxy, and not a new object
      // (new objects don't need proxying, they will be processed in finalize anyway)
      return state.copy[prop] = createProxy(state, value);
    return value;
  } else {
    if (has(state.proxies, prop)) return state.proxies[prop];
    var _value = state.base[prop];
    if (!isProxy(_value) && isProxyable(_value)) return state.proxies[prop] = createProxy(state, _value);
    return _value;
  }
}
function set$1(state, prop, value) {
  if (!state.modified) {
    // Optimize based on value's truthiness. Truthy values are guaranteed to
    // never be undefined, so we can avoid the `in` operator. Lastly, truthy
    // values may be proxies, but falsy values are never proxies.
    var isUnchanged = value ? is(state.base[prop], value) || value === state.proxies[prop] : is(state.base[prop], value) && prop in state.base;
    if (isUnchanged) return true;
    markChanged(state);
  }
  state.assigned[prop] = true;
  state.copy[prop] = value;
  return true;
}
function deleteProperty(state, prop) {
  state.assigned[prop] = false;
  markChanged(state);
  delete state.copy[prop];
  return true;
}
function getOwnPropertyDescriptor(state, prop) {
  var owner = state.modified ? state.copy : has(state.proxies, prop) ? state.proxies : state.base;
  var descriptor = Reflect.getOwnPropertyDescriptor(owner, prop);
  if (descriptor && !(Array.isArray(owner) && prop === "length")) descriptor.configurable = true;
  return descriptor;
}
function defineProperty$1() {
  throw new Error("Immer does not support defining properties on draft objects.");
}
function markChanged(state) {
  if (!state.modified) {
    state.modified = true;
    state.copy = shallowCopy(state.base);
    // copy the proxies over the base-copy
    assign(state.copy, state.proxies); // yup that works for arrays as well
    if (state.parent) markChanged(state.parent);
  }
}

// creates a proxy for plain objects / arrays
function createProxy(parentState, base) {
  if (isProxy(base)) throw new Error("Immer bug. Plz report.");
  var state = createState(parentState, base);
  var proxy = Array.isArray(base) ? Proxy.revocable([state], arrayTraps) : Proxy.revocable(state, objectTraps);
  proxies.push(proxy);
  return proxy.proxy;
}
function produceProxy(baseState, producer, patchListener) {
  var previousProxies = proxies;
  proxies = [];
  var patches = patchListener && [];
  var inversePatches = patchListener && [];
  try {
    // create proxy for root
    var rootProxy = createProxy(undefined, baseState);
    // execute the producer function
    var returnValue = producer.call(rootProxy, rootProxy);
    // and finalize the modified proxy
    var result = void 0;
    // check whether the draft was modified and/or a value was returned
    if (returnValue !== undefined && returnValue !== rootProxy) {
      // something was returned, and it wasn't the proxy itself
      if (rootProxy[PROXY_STATE].modified) throw new Error(RETURNED_AND_MODIFIED_ERROR);

      // we need to finalize the return value in case it's a subset of the draft
      result = finalize(returnValue);
      if (patches) {
        patches.push({
          op: "replace",
          path: [],
          value: result
        });
        inversePatches.push({
          op: "replace",
          path: [],
          value: baseState
        });
      }
    } else {
      result = finalize(rootProxy, [], patches, inversePatches);
    }
    // revoke all proxies
    each(proxies, function (_, p) {
      return p.revoke();
    });
    patchListener && patchListener(patches, inversePatches);
    return result;
  } finally {
    proxies = previousProxies;
  }
}

// @ts-check

var descriptors = {};
var states = null;
function createState$1(parent, proxy, base) {
  return {
    modified: false,
    assigned: {},
    // true: value was assigned to these props, false: was removed
    hasCopy: false,
    parent: parent,
    base: base,
    proxy: proxy,
    copy: undefined,
    finished: false,
    finalizing: false,
    finalized: false
  };
}
function source$1(state) {
  return state.hasCopy ? state.copy : state.base;
}
function _get(state, prop) {
  assertUnfinished(state);
  var value = source$1(state)[prop];
  if (!state.finalizing && value === state.base[prop] && isProxyable(value)) {
    // only create a proxy if the value is proxyable, and the value was in the base state
    // if it wasn't in the base state, the object is already modified and we will process it in finalize
    prepareCopy(state);
    return state.copy[prop] = createProxy$1(state, value);
  }
  return value;
}
function _set(state, prop, value) {
  assertUnfinished(state);
  state.assigned[prop] = true; // optimization; skip this if there is no listener
  if (!state.modified) {
    if (is(source$1(state)[prop], value)) return;
    markChanged$1(state);
    prepareCopy(state);
  }
  state.copy[prop] = value;
}
function markChanged$1(state) {
  if (!state.modified) {
    state.modified = true;
    if (state.parent) markChanged$1(state.parent);
  }
}
function prepareCopy(state) {
  if (state.hasCopy) return;
  state.hasCopy = true;
  state.copy = shallowCopy(state.base);
}

// creates a proxy for plain objects / arrays
function createProxy$1(parent, base) {
  var proxy = shallowCopy(base);
  each(base, function (i) {
    Object.defineProperty(proxy, "" + i, createPropertyProxy("" + i));
  });
  var state = createState$1(parent, proxy, base);
  createHiddenProperty(proxy, PROXY_STATE, state);
  states.push(state);
  return proxy;
}
function createPropertyProxy(prop) {
  return descriptors[prop] || (descriptors[prop] = {
    configurable: true,
    enumerable: true,
    get: function get$$1() {
      return _get(this[PROXY_STATE], prop);
    },
    set: function set$$1(value) {
      _set(this[PROXY_STATE], prop, value);
    }
  });
}
function assertUnfinished(state) {
  if (state.finished === true) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(state.copy || state.base));
}

// this sounds very expensive, but actually it is not that expensive in practice
// as it will only visit proxies, and only do key-based change detection for objects for
// which it is not already know that they are changed (that is, only object for which no known key was changed)
function markChangesSweep() {
  // intentionally we process the proxies in reverse order;
  // ideally we start by processing leafs in the tree, because if a child has changed, we don't have to check the parent anymore
  // reverse order of proxy creation approximates this
  for (var i = states.length - 1; i >= 0; i--) {
    var state = states[i];
    if (state.modified === false) {
      if (Array.isArray(state.base)) {
        if (hasArrayChanges(state)) markChanged$1(state);
      } else if (hasObjectChanges(state)) markChanged$1(state);
    }
  }
}
function markChangesRecursively(object) {
  if (!object || (typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") return;
  var state = object[PROXY_STATE];
  if (!state) return;
  var proxy = state.proxy,
    base = state.base,
    assigned = state.assigned;
  if (!Array.isArray(object)) {
    // Look for added keys.
    Object.keys(proxy).forEach(function (key) {
      // The `undefined` check is a fast path for pre-existing keys.
      if (base[key] === undefined && !has(base, key)) {
        assigned[key] = true;
        markChanged$1(state);
      } else if (!assigned[key]) {
        // Only untouched properties trigger recursion.
        markChangesRecursively(proxy[key]);
      }
    });
    // Look for removed keys.
    Object.keys(base).forEach(function (key) {
      // The `undefined` check is a fast path for pre-existing keys.
      if (proxy[key] === undefined && !has(proxy, key)) {
        assigned[key] = false;
        markChanged$1(state);
      }
    });
  } else if (hasArrayChanges(state)) {
    markChanged$1(state);
    assigned.length = true;
    if (proxy.length < base.length) {
      for (var i = proxy.length; i < base.length; i++) {
        assigned[i] = false;
      }
    } else {
      for (var _i = base.length; _i < proxy.length; _i++) {
        assigned[_i] = true;
      }
    }
    for (var _i2 = 0; _i2 < proxy.length; _i2++) {
      // Only untouched indices trigger recursion.
      if (assigned[_i2] === undefined) markChangesRecursively(proxy[_i2]);
    }
  }
}
function hasObjectChanges(state) {
  var base = state.base,
    proxy = state.proxy;

  // Search for added keys. Start at the back, because non-numeric keys
  // are ordered by time of definition on the object.

  var keys = Object.keys(proxy);
  for (var i = keys.length - 1; i >= 0; i--) {
    // The `undefined` check is a fast path for pre-existing keys.
    if (base[keys[i]] === undefined && !has(base, keys[i])) {
      return true;
    }
  }

  // Since no keys have been added, we can compare lengths to know if an
  // object has been deleted.
  return keys.length !== Object.keys(base).length;
}
function hasArrayChanges(state) {
  var proxy = state.proxy;
  if (proxy.length !== state.base.length) return true;
  // See #116
  // If we first shorten the length, our array interceptors will be removed.
  // If after that new items are added, result in the same original length,
  // those last items will have no intercepting property.
  // So if there is no own descriptor on the last position, we know that items were removed and added
  // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
  // the last one
  var descriptor = Object.getOwnPropertyDescriptor(proxy, proxy.length - 1);
  // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)
  if (descriptor && !descriptor.get) return true;
  // For all other cases, we don't have to compare, as they would have been picked up by the index setters
  return false;
}
function produceEs5(baseState, producer, patchListener) {
  var prevStates = states;
  states = [];
  var patches = patchListener && [];
  var inversePatches = patchListener && [];
  try {
    // create proxy for root
    var rootProxy = createProxy$1(undefined, baseState);
    // execute the thunk
    var returnValue = producer.call(rootProxy, rootProxy);
    // and finalize the modified proxy
    each(states, function (_, state) {
      state.finalizing = true;
    });
    var result = void 0;
    // check whether the draft was modified and/or a value was returned
    if (returnValue !== undefined && returnValue !== rootProxy) {
      // something was returned, and it wasn't the proxy itself
      if (rootProxy[PROXY_STATE].modified) throw new Error(RETURNED_AND_MODIFIED_ERROR);
      result = finalize(returnValue);
      if (patches) {
        patches.push({
          op: "replace",
          path: [],
          value: result
        });
        inversePatches.push({
          op: "replace",
          path: [],
          value: baseState
        });
      }
    } else {
      if (patchListener) markChangesRecursively(rootProxy);
      markChangesSweep(); // this one is more efficient if we don't need to know which attributes have changed
      result = finalize(rootProxy, [], patches, inversePatches);
    }
    // make sure all proxies become unusable
    each(states, function (_, state) {
      state.finished = true;
    });
    patchListener && patchListener(patches, inversePatches);
    return result;
  } finally {
    states = prevStates;
  }
}
function createHiddenProperty(target, prop, value) {
  Object.defineProperty(target, prop, {
    value: value,
    enumerable: false,
    writable: true
  });
}

/**
 * produce takes a state, and runs a function against it.
 * That function can freely mutate the state, as it will create copies-on-write.
 * This means that the original state will stay unchanged, and once the function finishes, the modified state is returned
 *
 * @export
 * @param {any} baseState - the state to start with
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the base state if nothing was modified
 */
function produce(baseState, producer, patchListener) {
  // prettier-ignore
  if (arguments.length < 1 || arguments.length > 3) throw new Error("produce expects 1 to 3 arguments, got " + arguments.length);

  // curried invocation
  if (typeof baseState === "function" && typeof producer !== "function") {
    var initialState = producer;
    var recipe = baseState;
    return function () {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var currentState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      return produce(currentState, function (draft) {
        return recipe.call.apply(recipe, [draft, draft].concat(args));
      });
    };
  }

  // prettier-ignore
  {
    if (typeof producer !== "function") throw new Error("if first argument is not a function, the second argument to produce should be a function");
    if (patchListener !== undefined && typeof patchListener !== "function") throw new Error("the third argument of a producer should not be set or a function");
  }

  // avoid proxying anything except plain objects and arrays
  if (!isProxyable(baseState)) {
    var returnValue = producer(baseState);
    return returnValue === undefined ? baseState : normalizeResult(returnValue);
  }

  // See #100, don't nest producers
  if (isProxy(baseState)) {
    var _returnValue = producer.call(baseState, baseState);
    return _returnValue === undefined ? baseState : normalizeResult(_returnValue);
  }
  return normalizeResult(getUseProxies() ? produceProxy(baseState, producer, patchListener) : produceEs5(baseState, producer, patchListener));
}
function normalizeResult(result) {
  return result === NOTHING ? undefined : result;
}
var applyPatches$1 = produce(applyPatches);
var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var ToolTipController = function (_React$PureComponent) {
  inherits(ToolTipController, _React$PureComponent);
  function ToolTipController(props) {
    classCallCheck(this, ToolTipController);
    var _this = possibleConstructorReturn(this, (ToolTipController.__proto__ || Object.getPrototypeOf(ToolTipController)).call(this, props));
    _this.state = {
      divStyle: {
        position: "absolute",
        top: 0,
        left: 0,
        transitionDuration: _this.props.duration,
        transitionTimingFunction: _this.props.timing,
        transitionProperty: _this.props.properties
      },
      isOpen: false,
      animate: false,
      timeOutID: null,
      tooltipWidth: 0,
      trigger: _this.props.triggerClose
    };
    _this.openMenu = function (e) {
      e.preventDefault();
      if (!_this.state.animate) {
        //Set timeout for menu to close automatically
        if (_this.props.timeOut !== null && _this.props.detect !== "hover-interact") {
          var timeOutID = setTimeout(function () {
            return _this.closeMenu();
          }, _this.props.timeOut);
          _this.setState({
            timeOutID: timeOutID
          });
        }
        if (_this.props.returnState !== null) {
          // Return menu status
          _this.setState({
            isOpen: true
          }, function () {
            return _this.props.returnState(_this.state.isOpen);
          });
        } else {
          // Just open the menu
          _this.setState({
            isOpen: true
          });
        }

        //Turn on the animation > adds the specific animation class
        if (_this.props.animation !== "") {
          setTimeout(function () {
            _this.setState({
              animate: true
            });
            //Add the pointer events from all the active DIVs
            _this.tooltip.current.style.pointerEvents = "auto";
          }, 0);
        }
      }
    };
    _this.closeMenu = function () {
      // Clear time out
      if (_this.props.timeOut !== null && _this.props.detect !== "hover-interact") {
        clearTimeout(_this.state.timeOutID);
      }
      //Turn off the animation > removes the specific animation class
      if (_this.state.isOpen) {
        if (_this.props.animation !== "") {
          // Return menu status
          if (_this.props.returnState !== null) {
            _this.setState({
              animate: false
            }, function () {
              return _this.props.returnState(_this.state.animate);
            });
          } else {
            _this.setState({
              animate: false
            });
          }
          //Remove pointer events from all the active DIVs
          _this.tooltip.current.style.pointerEvents = "none";
        } else {
          if (_this.props.returnState !== null) {
            _this.setState({
              isOpen: false
            }, function () {
              return _this.props.returnState(_this.state.isOpen);
            });
          } else {
            _this.setState({
              isOpen: false
            });
          }
        }
      }
    };
    _this.timeOutFunc = function () {
      var timeOutID = setTimeout(function () {
        return _this.closeMenu();
      }, _this.props.timeOut);
      _this.setState({
        timeOutID: timeOutID
      });
    };
    _this.clearTimeoutFunc = function () {
      clearTimeout(_this.state.timeOutID);
    };
    _this.resize = function (getElementBounding, selector) {
      var _this$props = _this.props,
        offsetX = _this$props.offsetX,
        offsetY = _this$props.offsetY;
      if (offsetX === "center" || offsetX === "centre") {
        _this.setState(produce(function (draft) {
          draft.divStyle.left = getElementBounding.left + (getElementBounding.width - _this.state.tooltipWidth) / 2;
          draft.divStyle.top = getElementBounding.top + getElementBounding.height + offsetY + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
        }));
      } else {
        _this.setState(produce(function (draft) {
          draft.divStyle.left = getElementBounding.left + offsetX;
          draft.divStyle.top = getElementBounding.top + getElementBounding.height + offsetY + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
        }));
      }
    };
    _this.tooltip = React.createRef();
    return _this;
  }
  createClass(ToolTipController, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProp, prevState) {
      var _this2 = this;
      if (this.state.isOpen) {
        this.setState({
          tooltipWidth: this.tooltip.current.getBoundingClientRect().width
        });
      }
      if (prevProp.triggerClose !== this.props.triggerClose) {
        this.closeMenu();
      }
      setTimeout(function () {
        if (_this2.props.animation !== "") {
          if (_this2.state.animate) {
            window.addEventListener('click', _this2.closeMenu);
            window.addEventListener('touchend', _this2.closeMenu);
          } else {
            window.removeEventListener('click', _this2.closeMenu);
            window.removeEventListener('touchend', _this2.closeMenu);
          }
        } else {
          if (_this2.state.isOpen) {
            window.addEventListener('click', _this2.closeMenu);
            window.addEventListener('touchend', _this2.closeMenu);
          } else {
            window.removeEventListener('click', _this2.closeMenu);
            window.removeEventListener('touchend', _this2.closeMenu);
          }
        }
      }, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.closeMenu);
      window.removeEventListener('touchstart', this.closeMenu);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var _props = this.props,
        id = _props.id,
        children = _props.children,
        animation = _props.animation,
        closeOnClick = _props.closeOnClick,
        detect = _props.detect;
      var _state = this.state,
        isOpen = _state.isOpen,
        animate = _state.animate,
        divStyle = _state.divStyle;
      var inputChildren = React.Children.map(children, function (child, index) {
        if (child.type.displayName === "Select") {
          return React.cloneElement(child, {
            detect: detect,
            openMenu: _this3.openMenu,
            closeMenu: _this3.closeMenu,
            timeOutFunc: _this3.timeOutFunc,
            resize: _this3.resize
          });
        } else {
          return isOpen && ReactDOM.createPortal(React.createElement('span', {
            ref: _this3.tooltip,
            className: animate ? 'react-tooltip-absolute-container react-tooltip-' + id + ' ' + animation : 'react-tooltip-absolute-container react-tooltip-' + id,
            style: divStyle,
            onClick: closeOnClick ? null : function (e) {
              return e.stopPropagation();
            },
            onTouchEnd: function onTouchEnd(e) {
              return e.stopPropagation();
            },
            onMouseEnter: detect === "hover-interact" ? _this3.clearTimeoutFunc : undefined,
            onMouseLeave: detect === "hover-interact" ? _this3.closeMenu : undefined
          }, React.cloneElement(child)), document.body);
        }
      });
      return inputChildren;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.triggerClose !== prevState.trigger) {
        return {
          trigger: nextProps.triggerClose
        };
      } else {
        return false;
      }
    }
  }]);
  return ToolTipController;
}(React.PureComponent);
ToolTipController.defaultProps = {
  offsetX: 0,
  offsetY: 0,
  detect: "click",
  closeOnClick: true,
  timeOut: null,
  animation: "",
  duration: "",
  timing: "",
  properties: [],
  returnState: null,
  id: ""
};
var Select = function (_React$Component) {
  inherits(Select, _React$Component);
  function Select(props) {
    classCallCheck(this, Select);
    var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
    _this.resize = function () {
      _this.props.resize(_this.getElementBounding(), _this.refs.selector);
    };
    _this.getElementBounding = function () {
      var rect = ReactDOM.findDOMNode(_this.selector.current).getBoundingClientRect();
      return {
        left: rect.left,
        top: rect.top,
        height: rect.height,
        width: rect.width
      };
    };
    _this.selector = React.createRef();
    return _this;
  }
  createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.resize();
      window.addEventListener('resize', this.resize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.resize();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        detect = _props.detect,
        openMenu = _props.openMenu,
        closeMenu = _props.closeMenu,
        timeOutFunc = _props.timeOutFunc,
        children = _props.children;
      if (detect === "click") {
        return React.cloneElement(children, {
          ref: this.selector,
          onClick: openMenu,
          onTouchEnd: openMenu
        });
      } else if (detect === 'hover') {
        return React.cloneElement(children, {
          ref: this.selector,
          onMouseEnter: openMenu,
          onMouseLeave: closeMenu,
          onTouchEnd: openMenu
        });
      } else if (detect === 'hover-hold') {
        return React.cloneElement(children, {
          ref: this.selector,
          onMouseEnter: openMenu,
          onTouchEnd: openMenu
        });
      } else if (detect === 'hover-interact') {
        return React.cloneElement(children, {
          ref: this.selector,
          onMouseEnter: openMenu,
          onMouseLeave: timeOutFunc,
          onTouchEnd: openMenu
        });
      }
      return null;
    }
  }]);
  return Select;
}(React.Component);
Select.displayName = 'Select';
export { ToolTipController, Select };